import React from 'react';
import styles from './news-feed-item.module.scss';
import { isToday } from 'shared/utils/date.utils';
import { useDateFormatter } from 'shared/hooks/dates.hooks';
import { Link } from 'react-router-dom';
import {
  COMMUNICATION_CENTER_NAVIGATION_SOURCE,
  COMMUNICATIONS_TYPES,
  EVENTS,
  ROUTES,
} from 'shared/constants';
import { UserAvatar } from 'src/components/avatar';
import { formatFullName } from 'shared/utils';
import { useKnowledgeParser } from 'shared/utils/rotations';
import { useSelector } from 'react-redux';
import analyticsService from 'src/helpers/analytics.service';
import { AttachmentsBadge } from '../../design-system/attachments-badge';

export function RegularNotification({
  id,
  title,
  createdAt,
  user,
  attachmentsCount,
  attachments = [],
  source = COMMUNICATION_CENTER_NAVIGATION_SOURCE.DASHBOARD_WIDGET,
  type = COMMUNICATIONS_TYPES.REGULAR,
}) {
  const { formatShortDateTime, formatShortTime } = useDateFormatter();
  const { parse } = useKnowledgeParser({
    knowledge: useSelector(state => state.knowledge),
    admission: useSelector(state => state.admission),
    lab: useSelector(state => state.lab),
    resources: attachments,
  });
  const fullName = user ? `${formatFullName(user)}, ` : '';

  const onNavigateToNotification = () => {
    analyticsService.track(EVENTS.COMMUNICATION_CENTER.NOTIFICATION_CLICKED, {
      notificationId: id,
      source,
      type,
    });
  };

  const renderAttachment = () => {
    if (!attachmentsCount) {
      return null;
    }

    if (attachmentsCount === 1) {
      // A button, not IconAnchor: an <a> here would nest inside the card's <Link>
      const handleAttachmentClick = e => {
        e.preventDefault();
        e.stopPropagation();
        const navigateTo = parse(attachments[0])?.navigateTo;
        if (navigateTo) {
          window.open(navigateTo, '_blank', 'noopener,noreferrer');
        }
      };

      return (
        <AttachmentsBadge
          variant="plain"
          count={attachmentsCount}
          onClick={handleAttachmentClick}
        />
      );
    }

    return <AttachmentsBadge variant="plain" count={attachmentsCount} />;
  };

  return (
    <Link
      to={ROUTES.COMMUNICATION_ITEM.replace(':id', id)}
      onClick={onNavigateToNotification}
      className={styles.link}>
      <div className={styles.root}>
        <div className={styles.rightSide}>
          <UserAvatar user={user} size="small" />
          <div className={styles.body}>
            <p className={styles.title}>{title}</p>
            <label className={styles.date}>
              {fullName}
              {isToday(createdAt) ? formatShortTime(createdAt) : formatShortDateTime(createdAt)}
            </label>
          </div>
        </div>
        {renderAttachment()}
      </div>
    </Link>
  );
}
